export default {"src":"/_next/static/media/logo.6e47a5b5.svg","height":135,"width":930};